import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAlert, useAxios } from "../../hooks";
import React from "react";
import { styled } from "@mui/material/styles";
import {
  Dialog,
  DialogContent,
  Typography,
  Grid,
  Box,
  Button,
} from "@mui/material";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import CloseIcon from "@mui/icons-material/Close";
import { LoadingButton } from "../../components";
import { useDispatch } from "react-redux";

const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    borderRadius: "15px",
    background: "#fff",
    overflow: "hidden",
    [theme.breakpoints.up("sm")]: {
      width: "85%",
    },
    [theme.breakpoints.up("md")]: {
      width: "50%",
    },
    [theme.breakpoints.up("lg")]: {
      width: "35%",
    },
  },
}));

const HeaderBox = styled(Box)(({ color }) => ({
  background: color,
  padding: "25px 20px 30px",
  textAlign: "center",
  position: "relative",
}));

const ContentBox = styled(Box)(({ theme }) => ({
  padding: "20px",
  textAlign: "center",
  [theme.breakpoints.down("sm")]: {
    padding: "16px",
  },
}));

function UserStatus({ userStatus, setUserStatus, setUserData, userData }) {
  const axios = useAxios();
  const dispatch = useDispatch();
  const { alert } = useAlert();

  const [loading, setLoading] = useState(false);

  const maskPhone = (phone) => {
    if (!phone) return "";
    return phone.replace(/.(?=.{4})/g, "*");
  };

  function handleDeleteData() {
    setLoading(true);

    axios({
      url: "event/verify/delete-face",
      data: { visitor_id: userData?.visitor_obj?._id },
      method: "POST",
    }).then((resp) => {
      if (resp.status) {
        setUserStatus(false);
        // setUserData({});
        dispatch(
          alert({
            type: "success",
            message: resp?.message?.displayMessage,
          })
        );
      } else {
        dispatch(
          alert({
            type: "error",
            message: resp?.message?.displayMessage,
          })
        );
      }
      setLoading(false);
    });
  }

  return (
    <StyledDialog open={userStatus} fullWidth maxWidth="sm">
      <>
        <HeaderBox color="#d71111ff">
          <ErrorIcon sx={{ fontSize: "55px", color: "#fff" }} />
          <Typography variant="h5" fontWeight={700} color="white" mt={2}>
            {userData?.visitor_obj?.phone_number
              ? `User Already Registered With : ${maskPhone(
                  userData?.visitor_obj?.phone_number
                )}`
              : "Error"}
          </Typography>
        </HeaderBox>
        <DialogContent>
          <ContentBox>
            <Grid item xs={12}>
              {userData?.visitor_obj?.phone_number ? (
                <Typography variant="body1" fontWeight={500} mt={2}>
                  {" "}
                  Deleting this visitor will permanently remove their records.
                  You won’t be able to check them in or take any further action
                </Typography>
              ) : typeof userData?.message != "string" ? (
                userData?.message?.map((item, index) => (
                  <Typography variant="body1" fontWeight={500} mt={2}>
                    {`${index + 1}. ${item}`}
                  </Typography>
                ))
              ) : (
                <Typography variant="body1" fontWeight={500} mt={2}>
                  {userData?.message}
                </Typography>
              )}
            </Grid>

            {userData?.visitor_obj?.phone_number && (
              <Grid item xs={12}>
                <LoadingButton
                  id="click-photo"
                  type="button"
                  loading={loading}
                  onClick={() => {
                    if (userData?.visitor_obj?.phone_number) {
                      handleDeleteData();
                    } else {
                      setUserStatus(false);

                      setUserData({});
                    }
                  }}
                  style={{
                    padding: "10px 45px",
                    width: "95%",
                    boxShadow: "none",
                  }}
                >
                  {`Delete Old Account`}
                </LoadingButton>
              </Grid>
            )}

            <Grid item xs={12}>
              <LoadingButton
                variant="outlined"
                onClick={() => {
                  setUserStatus(false);
                  setUserData({});
                }}
                style={{
                  padding: "10px 45px",
                  width: "95%",
                  marginTop: "5px",
                  boxShadow: "none",
                  color: "black",
                  border: "1px solid",
                }}
                backgroundColor="white"
              >
                Try Again
              </LoadingButton>
            </Grid>
          </ContentBox>
        </DialogContent>
      </>
    </StyledDialog>
  );
}

export default UserStatus;
